import { FC } from 'react';
import { CheckCircle } from 'lucide-react';


interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  details?: string[];
}

const SuccessModal: FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title = 'Успешно',
  message,
  details,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 transition-opacity animate-fadeIn">
      <div className="bg-white dark:bg-zinc-900 rounded-xl shadow-lg w-full max-w-md p-6 border border-gray-100 dark:border-zinc-800 transform transition-all scale-100 hover:scale-[1.02] duration-150 ease-out">
        <div className="flex items-center mb-4">
          <CheckCircle className="w-12 h-12 text-green-500 mr-3" />
          <h2 className="text-xl font-bold text-gray-900 dark:text-zinc-100">{title}</h2>
        </div>

        <p className="text-gray-700 dark:text-zinc-200 mb-4 leading-relaxed whitespace-pre-line">
          {message}
        </p>
        
        {details && details.length > 0 && (
          <div className="mb-4 p-3 bg-gray-50 dark:bg-zinc-900 rounded-lg border border-gray-200 dark:border-zinc-800 max-h-48 overflow-y-auto">
            <p className="text-sm font-medium text-gray-700 dark:text-zinc-200 mb-2">Детали:</p>
            <ul className="text-sm text-gray-600 dark:text-zinc-300 space-y-1">
              {details.map((detail, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-green-500 mr-2">•</span>
                  <span>{detail}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-8 rounded-lg shadow-sm transition-transform transform hover:scale-105"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;

